var map = {
	"./American- Football.webp": 1796,
	"./Australian-Rules.svg": 8883,
	"./Baseball.webp": 6668,
	"./Cricket.webp": 2850,
	"./Darts.webp": 3994,
	"./Football.webp": 2748,
	"./Greyhound-Racing.webp": 7763,
	"./Handball.webp": 823,
	"./Horse-Racing-1.webp": 6655,
	"./Politics.png": 6370,
	"./Rugby-Union.webp": 8924,
	"./Rugby.webp": 8091,
	"./Snooker.webp": 1375,
	"./Tennis.webp": 7152,
	"./basketball.png": 9142,
	"./boxing-glove.png": 5205,
	"./cricket.png": 6583,
	"./cycling.png": 1129,
	"./esportspng.png": 8909,
	"./football.png": 451,
	"./gaelic-games.svg": 7540,
	"./game_default_icon.svg": 160,
	"./golf.png": 6270,
	"./ice-hocky.webp": 4913,
	"./martial-arts.png": 6549,
	"./menu-cricket.webp": 445,
	"./menu-soccer.webp": 4164,
	"./menu-tennis.svg": 503,
	"./moto-sports.png": 5724,
	"./sidemenu6.webp": 2775,
	"./sidemenu7.webp": 4998,
	"./special-bets.png": 6524,
	"./table-tennis.png": 7401,
	"./volleyball.png": 8110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2250;